type FieldErrorProps = {
  id: string
  message?: string
}

export function FieldError({ id, message }: FieldErrorProps) {
  if (!message) return null
  return <span className="field-error" id={id}>{message}</span>
}

type CharacterCounterProps = {
  id: string
  current: number
  maximum: number
}

export function CharacterCounter({ id, current, maximum }: CharacterCounterProps) {
  return <span className="field-counter" id={id}>{current} / {maximum}</span>
}
